var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInclusiveResource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.557 11.3796L19.4309 10.5209C19.99 10.4011 20.1897 9.70222 19.7903 9.28288L18.9316 8.42424L22.526 4.82992C22.8854 4.47048 22.8854 3.8914 22.526 3.53196C22.1665 3.17253 21.5875 3.17253 21.228 3.53196L17.6337 7.12629L16.7751 6.26765C16.3757 5.86828 15.6768 6.06796 15.537 6.62708L14.6784 10.501C14.5785 11.0401 15.0378 11.4994 15.557 11.3796Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.084 14.1353L7.21015 14.9939C6.65103 15.1137 6.45134 15.8126 6.85071 16.232L7.70936 17.0906L4.11503 20.6849C3.7556 21.0444 3.7556 21.6234 4.11503 21.9829C4.29475 22.1626 4.53437 22.2624 4.77399 22.2624C5.01361 22.2624 5.25324 22.1626 5.43295 21.9829L9.02728 18.3886L9.88592 19.2472C10.2853 19.6466 10.9842 19.4469 11.124 18.8878L11.9826 15.0139C12.0625 14.4747 11.6032 14.0155 11.084 14.1353Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9516 17.0706L19.8103 16.2119C20.2096 15.8126 20.0099 15.1137 19.4508 14.9739L15.5769 14.1153C15.0578 13.9954 14.5985 14.4747 14.6983 14.9939L15.557 18.8677C15.6768 19.4269 16.3757 19.6266 16.795 19.2272L17.6537 18.3685L21.248 21.9629C21.4277 22.1426 21.6673 22.2424 21.907 22.2424C22.1466 22.2424 22.3862 22.1426 22.5659 21.9629C22.9253 21.6034 22.9253 21.0243 22.5659 20.6649L18.9516 17.0706Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.084 6.6272C10.9642 6.06808 10.2653 5.86839 9.84598 6.26776L8.98734 7.12641L5.39302 3.53208C5.05355 3.17265 4.47447 3.17265 4.11503 3.55205C3.7556 3.93145 3.7556 4.49057 4.11503 4.85L7.70936 8.44433L6.85071 9.30297C6.45134 9.70234 6.65103 10.4012 7.21015 10.541L11.084 11.3997C11.6032 11.5195 12.0625 11.0402 11.9626 10.521L11.084 6.6272Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInclusiveResource);
export default __webpack_public_path__ + "static/media/inclusive-resource.9f50b53ee56e3253e5ce946691b66241.svg";
export { ForwardRef as ReactComponent };